'use strict';

var isValidEmail = require('./isValidEmail');

function validateEmail(email) {
  if (!email) {
    return {
      error: 'Required'
    };
  }

  if (!isValidEmail(email)) {
    return {
      error: 'Invalid email'
    };
  }
}

module.exports = validateEmail;


/** WEBPACK FOOTER **
 ** ./utils/validateEmail.js
 **/